var map = {
	"./_birthday": 411,
	"./_birthday.vue": 411,
	"./base": 148,
	"./base.vue": 148
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1252;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/thank-you ^\.\/.*$
// module id = 1252
// module chunks = 0